import styled from '@emotion/styled';

import { Link as GatsbyLink } from 'gatsby';
import { fontWeight } from '~/styles';

export const Link = styled(GatsbyLink)`
  font-weight: ${fontWeight.semiBold};
  &:hover {
    text-decoration: none;
  }
`;
